module.exports = __webpack_public_path__ + "static/img/pic_topbg_gmcg@2x.df993093.png";